import { render, staticRenderFns } from "./OnBoardingBox.vue?vue&type=template&id=ab9f9fc2&scoped=true&"
import script from "./OnBoardingBox.vue?vue&type=script&lang=js&"
export * from "./OnBoardingBox.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingBox.vue?vue&type=style&index=0&id=ab9f9fc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9f9fc2",
  null
  
)

export default component.exports